




































































































































import Accordion from "@/components/shared/Accordion.vue";
import { QuotationCustomDutyItem } from "@/model/component.model";
import { ZonosProformaDetailsDTO } from "@/model/data.model";
import { getCurrencies } from "@/services/AuthService";
import cloneDeep from "lodash/cloneDeep";
import Vue from "vue";
import { downloadFile, isPortugal } from "@/services/Helpers";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import CustomDutyItem from "./CustomDutyItem.vue";
import { ShipmentCalculateCostClass } from "@/model/ShipmentCalculateCostClass";
import { TaxDutyService } from "@/services/TaxDutyService";

@Component({
  components: {
    MbeAccordion: Accordion,
    CustomDutyItem
  }
})
export default class CustomDutiesQuoteSection extends Vue {
  @Prop() calculateCostClass: ShipmentCalculateCostClass;
  @Prop() typeShipment: string;
  triggerCalculate = false;
  totalCustomDutyAmount = "";
  currencies: string[] = [];
  taxDutyCurrentMonthCallAmount = 0;
  currency: null | undefined | string = null;
  language: null | string = this.currentLang;
  items: QuotationCustomDutyItem[] = [
    {
      category: "",
      hsCode: "",
      singleValue: 0,
      description: "",
      gender: "",
      material: "",
      weight: 0,
      quantity: 1,
      isValid: false,
      totalValue: 0
    }
  ];

  addLine() {
    this.items.push({
      category: "",
      hsCode: "",
      singleValue: 0,
      description: "",
      gender: "",
      material: "",
      weight: 0,
      quantity: 1,
      isValid: false,
      totalValue: 0
    });
  }

  @Validations()
  validations() {
    return {
      currency: {
        required
      },
      language: {
        required
      }
    };
  }

  get showTaxDutyLogic() {
    return (
      this.$store.getters["shipment/enableTaxDutySection"] &&
      this.isTaxDutyEnabled
    );
  }

  get isTaxDutyEnabled() {
    return this.$store.getters["customer/isTaxDutyEnabled"] as boolean;
  }

  async initTaxDutyCurrentMonthAmount() {
    try {
      this.taxDutyCurrentMonthCallAmount = await TaxDutyService.prototype.getCurrentMonthCallAmount();
    } catch (err) {
      console.error(err);
    }
  }

  get visible() {
    if (!this.showTaxDutyLogic) return false;
    if (!this.calculateCostClass) return false;
    if (
      !this.calculateCostClass.addressFrom ||
      !this.calculateCostClass.addressTo
    )
      return false;
    const toCountry = this.calculateCostClass.addressTo.country?.id;
    const fromCountry = this.calculateCostClass.addressFrom.country?.id;
    const toSubcountryCee = this.calculateCostClass.addressTo.subcountry?.cee;
    const fromSubcountryCee = this.calculateCostClass.addressFrom.subcountry
      ?.cee;
    const toSubcountry = this.calculateCostClass.addressFrom.subcountry
      ?.description;
    if (!toCountry || !fromCountry || !toSubcountry) return false;
    return (
      (!toSubcountryCee || !fromSubcountryCee) &&
      this.typeShipment !== "DOMESTIC"
    );
  }

  get zonosProformaDetails() {
    if (!this.items || !this.items.length) return [];
    return this.items.map((item: QuotationCustomDutyItem, index: number) => {
      const hsCode = item.hsCode ? item.hsCode : null;
      const category = item.category ? item.category : "";
      const gender = item.gender ? item.gender : "";
      const material = item.material ? item.material : "";
      const position = index;
      return {
        position,
        countryOfOrigin: this.calculateCostClass.addressFrom.country.id,
        itemsNumber: item.quantity,
        itemsTotalValue: item.totalValue,
        description: item.description,
        itemsSingleValue: item.singleValue,
        descriptiveRow: false,
        weight: item.weight,
        hsCode,
        category,
        gender,
        material,
        measureOfMeasurement: "",
        measureOfMeasurementSecondary: "",
        articleId: 0,
        type: 0,
        coefficient: 0,
        currency: this.currency
      } as ZonosProformaDetailsDTO;
    });
  }

  get defaultStoreCurrency() {
    return this.$store.getters["currency"] as string;
  }

  get itemsInvalid() {
    return this.items.some((el: QuotationCustomDutyItem) => !el.isValid);
  }

  get currentLang(): string {
    return this.$store.state.language;
  }

  get languages() {
    return this.$store.state.languages;
  }

  deleteItem(index: number) {
    this.items.splice(index, 1);
  }

  @Watch("triggerCalculate")
  onTriggerCalculateChange(status: boolean) {
    this.$emit("updateCustomDutiesFlag", status);
    if (!status) return;
    this.$emit("zonosDetails", {
      proformaDetails: cloneDeep(this.zonosProformaDetails),
      language: this.language
    });
  }

  created() {
    this.loadCurrencies();
    this.initTaxDutyCurrentMonthAmount();
  }

  loadCurrencies() {
    getCurrencies().then((res: any) => {
      if (isPortugal()) {
        this.currencies = res
          .filter((el: any) => el.code === "EUR")
          .map((el: any) => el.code);
      } else {
        this.currencies = res.map((el: any) => {
          return el.code;
        });
      }
      if (this.defaultStoreCurrency) {
        this.currency = cloneDeep(this.currencies).find(
          (el: string) => el.length > 0 && el === this.defaultStoreCurrency
        );
      }
    });
  }

  async getDetailsExport() {
    try {
      const file = await TaxDutyService.prototype.getDetailsExportFile();
      downloadFile(file, "plain/csv", "counter_details_export.csv", this);
    } catch (err) {
      console.error(err);
    }
  }

  syncModel(index: number, model: QuotationCustomDutyItem) {
    this.items.splice(index, 1, model);
    this.triggerCalculate = false;
    this.totalCustomDutyAmount = "";
  }
}
